module.exports = __webpack_public_path__ + "img/Room.1ae84914.svg";